import React from 'react';
import ContentService from '../services/content.services';

class ContentController extends React.Component {
  constructor(props) {
    super(props);
  }

  async aboutUs() {
    let response = await ContentService.aboutUs();
    if (response && response.status) {
      return response;
    } else {
      // new Toaster().error(response.error);
      return null;
    }
  }

  async faq() {
    let response = await ContentService.faq();
    if (response && response.status) {
      return response;
    } else {
      //new Toaster().error(response.error);
      return null;
    }
  }

  async contactUs() {
    let response = await ContentService.contactUs();
    if (response && response.status) {
      return response;
    } else {
      //new Toaster().error(response.error);
      return null;
    }
  }

  async contactUsForm(data) {
    let post = {
      first_name: data.firstName,
      last_name: data.lastName,
      phonenumber: data.phoneNumber,
      email: data.email,
      message: data.message,
    };
    let response = await ContentService.contactUsForm(post);
    if (response && response.status) {
      return response;
    } else {
      // new Toaster().error(response.error);
      return null;
    }
  }

  async termsConditions() {
    let response = await ContentService.termsConditions();
    if (response && response.status) {
      return response;
    } else {
      // new Toaster().error(response.error);
      return null;
    }
  }

  async privacyPolicy() {
    let response = await ContentService.privacyPolicy();
    if (response && response.status) {
      return response;
    } else {
      // new Toaster().error(response.error);
      return null;
    }
  }

}

export default ContentController;
